import { IMemberState } from "../../types/memberTypes";
import {
  GET_ALL_MEBEBER_BENEFITS_DATA,
  GET_HERO_MEMEBER_DETAILS,
  GET_MEBEBER_DETAILS,
  RESET_MEMBER_DETAILS,
  SET_MEMBER_LIST_STATUS,
} from "../constants/memberConstant";

const init: IMemberState = {
  memberBenefits: {
    paginate: 25,
    total: 0,
    data: [],
    per_page: 25,
  },
  listStatus: false,
  detailStatus: false,
  memberDetails: null,
  heroMemberDetails: {},
};

const memberReducer = (state: IMemberState = init, action: any): IMemberState => {
  switch (action.type) {
    case GET_ALL_MEBEBER_BENEFITS_DATA: {
      return {
        ...state,
        memberBenefits: action.payload.data,
        listStatus: true,
      };
    }
    case GET_MEBEBER_DETAILS: {
      return {
        ...state,
        memberDetails: action.payload.data,
        detailStatus: true,
      };
    }
    case GET_HERO_MEMEBER_DETAILS: {
      return {
        ...state,
        heroMemberDetails: action.payload.data,
      };
    }
    case SET_MEMBER_LIST_STATUS: {
      return {
        ...state,
        listStatus: false,
      };
    }
    case RESET_MEMBER_DETAILS: {
      return {
        ...state,
        memberDetails: null,
        detailStatus: false,
      };
    }
    default:
      return state;
  }
};
export default memberReducer;
